import { Utils } from "../../../../../../services/utils.service";
import { DataCollection } from "../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../infrastructure/enums";
import { TransportData } from "../../../../../infrastructure/transportdata";

export class ProfileFetchRequest {
  public static readonly FetchRequestType: string = "profile_fetch_request";
  login_id: number = 0;
  profile_ids: number[] = [];
//   FinancialYearRef: number = 0;
//   Month: number = 0;
//   IsCalledForTransaction: boolean = false;

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      ProfileFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}
